/*
|--------------------------------------------------------------------------
| consumerMarketing: aggrego
|--------------------------------------------------------------------------
*/
/**
 * @namespace 
 */
__gh__webApp.consumerMarketing.aggrego = {
	
	/**
	 * Data
	 */
	"data":{
		"title"				:	'Stories from Headlines Network',
		"desktopAnchorId"	:	'exchange-embed-widget-0bd43',
		"mobileAnchorId"  	:	'exchange-embed-widget-0bd44',
		"desktopTag" 		:	'0bd438e69d954a043ba7ba0c7915b5db',
		"mobileTag" 		:	'4898b8cb51e34dd0e425d0a02b48b6b5',
		"desktopNewEnglandTag" 		:	'd2fb59637bfaca692c38281896fe63cb',
		"sports"			:	'cbe032709a806804519d8aa1d01dfd23',
		"tag"				:	'',
		"anchorId"			:	''
	},
	"init": function(){
		//debug.log("aggrego.init()")
		if (__gh__webApp.consumerMarketing.aggrego.isLoaded) {return;}
		
		
		//debug.log("__gh__webApp.consumerMarketing.aggrego.isLoaded = "+__gh__webApp.consumerMarketing.aggrego.isLoaded)
		
		var thisObject		= __gh__webApp.consumerMarketing.aggrego;
		thisObject.config();
		thisObject.configSites();

		if (this.isDisabled()) {return;}
		if (this.isDisabledTaxonomy()) {return;}
		if (this.shimOkanjo()) {return;}
		
		
		var elementExists = document.getElementById(data.anchorId);
		
		debug.log("elementExists="+elementExists)
		
		if(elementExists===null||__gh__webApp.consumerMarketing.aggrego.isLoaded == true){
			 return;
		}
		else{
			 __gh__webApp.consumerMarketing.aggrego.isLoaded = true;
		}
		
		thisObject.loadLibrary();
	},
	"config": function(){
		var thisObject		= __gh__webApp.consumerMarketing.aggrego;
			data 	= thisObject.data,
			data.tag=data.desktopTag,
			data.anchorId=data.mobileAnchorId,
			dfpTaxoMap=__gh__webApp.ads.dfp.taxonomyMap.taxonomy;
			
		var dfpNameSpace=__gh__webApp.ads.dfp,
			taxonomy=dfpNameSpace.defineArticleKeywords(),
			taxo_split = taxonomy.split(',');
			
			$.each(taxo_split, function(k, v) {
			    if(dfpTaxoMap[v] !== undefined){
				    var key=dfpTaxoMap[v];
				    if(data[key] !== undefined){
					    data.tag=data[key];
					    //debug.log('Mapping data.tag='+data.tag)
					    return; 
				    }
			    }
			     
			}); 
	
		if(__gh__webApp.device.isPhone()){
			data.anchorId = data.mobileAnchorId;
			data.tag 	  = data.mobileTag;
		}
		else{
			data.anchorId = data.desktopAnchorId;
		}

		return;
	},
	"configSites": function(){
		var thisObject		= __gh__webApp.consumerMarketing.aggrego;
			data 	= thisObject.data,
			data.tag=data.tag,
			data.anchorId=data.anchorId;
	
		if(__gh__webApp.device.isPhone()){
			//do nothing
		}
		else{
			//NE only widget
			if(__gh__coreData["siteData"].siteCode=='WL'||__gh__coreData["3rdPartyData"].ads.dfp.firstLevelAdUnit=='capecodtimes.com'||__gh__coreData["3rdPartyData"].ads.dfp.firstLevelAdUnit=='seacoastonline.com'||__gh__coreData["3rdPartyData"].ads.dfp.firstLevelAdUnit=='fosters.com'){
				data.tag=data.desktopNewEnglandTag;
			}
		}

		return;
	},
	"loadLibrary": function(){
		var src,
			thisObject	= __gh__webApp.consumerMarketing.aggrego,
			data 		= thisObject.data;
		
		$( "h4.chatter-title" ).text(data.title);
		//change html_anchor_id based on device because div showing in different location
		
		src = '//headlinesnetwork.com/embed_widget.js?tag='+thisObject.data.tag+'&html_anchor_id='+thisObject.data.anchorId;
		
		__gh__webApp.common.loadScript({"src": src});
	},
	"isDisabledTaxonomy": function(){
		var dfpNameSpace=__gh__webApp.ads.dfp,
			taxonomy=dfpNameSpace.defineArticleKeywords(),
			isDisabledTaxonomy =(taxonomy.indexOf("obituaries")==-1) ? false : true;

		return isDisabledTaxonomy;
	},
	"isDisabled": function(){
		var commonJS = __gh__webApp.common,
			isDisabled =(commonJS.isObjectPropertySet(__gh__coreData["3rdPartyData"],"contentRecommendation.chatter.enabled") && __gh__coreData["3rdPartyData"].contentRecommendation.chatter.enabled) ? false : true;

		return isDisabled;
	},
	"shimOkanjo": function(){
		var thisObject	= __gh__webApp.consumerMarketing.aggrego,
			commonJS = __gh__webApp.common,
			noShim =(commonJS.isObjectPropertySet(__gh__coreData["3rdPartyData"],"ads.dfp.firstLevelAdUnit") && __gh__coreData["3rdPartyData"].ads.dfp.firstLevelAdUnit == 'fayobserver.com' && thisObject.data.tag==thisObject.data.sports) ? false : true;
		//debug.log('noShim'+noShim)
		if (noShim) {return false;}
		//debug.log('noShim'+noShim)
		__gh__webApp.consumerMarketing.aggrego.isLoaded = true;
		thisObject.loadOkanjoLibrary();

		return true;
	},
	"loadOkanjoLibrary": function(){
		var src,
			thisObject	= __gh__webApp.consumerMarketing.aggrego,
			data 		= thisObject.data
			playerHTML	= '<div class="creInject adConsumerRecommend" data-gh-lazy-ad-bucket-targeting=\'{"ad-type":"Rich Media","slot":"Consumer Recommend","sov":"base ROS","outofpage":"Consumer Recommend","creative-format":"Okanjo","dimension":"210x460"}\'></div>';
			
			if(__gh__webApp.device.isPhone()){
				playerHTML	= '<div class="creInject adConsumerRecommend" data-gh-lazy-ad-bucket-targeting=\'{"ad-type":"Rich Media","slot":"Consumer Recommend","sov":"base ROS","outofpage":"Consumer Recommend","creative-format":"Okanjo","dimension":"300x250"}\'></div>';
			}
			else{
				//do nothing
			}
			
		$('#'+thisObject.data.anchorId).after(playerHTML);
		
		var callbackObject = {
				"callback":function(data){
					var slotType  = 'Base'
					__gh__webApp.ads.dfp.createLazySlot(data,slotType);
					console.log(data)
				},
				"data": ".creInject"
			};
		__gh__webApp.ads.dfp.callFunction(callbackObject);
	}

};

__gh__webApp.consumerMarketing.aggrego.isLoaded = false;
